import service from './index'

const resource = service.resource('races{/id}/runners')
const addrunner = service.resource('races{/idRacer}/add-runner{/idRunner}')
const removerunner = service.resource('races/{idRacer}/remove-runner/{idRunner}')
// FIXED: Add bestDuration=true query parameter to match the working WebSocket API call
const runnerInfo = service.resource('runners/profile-info{/raceId}{?bestDuration}')
const runnerInfoPerId = service.resource('runners/profile-info/{ = runnerId}')
const runnerProfileInfo = service.resource('runners/profile-info')
const runnerBestDuration = service.resource('runners/best-by-duration/{ = runnerId}')
const runnerCurrentYearBestDuration = service.resource('runners/best-by-duration/{ = runnerId}{ = year}')
const runnerMedals = service.resource('runners/medal-analytics/{runnerId}')
const resourceSubscribed = service.resource('runners/{id}/get-subscribeds-races')
const resourceFinalposition = service.resource('race-resumes/final-positions/{raceResumeId}')
const runnerMemo = service.resource('runners/add-memo/{runnerId}')
const runnerCmMemo = service.resource('runners/add-cm-memo/{runnerId}')
const runnerUpdateDistance = service.resource('runners/update-result/{raceId}')
const runnerGetDistance = service.resource('runners/results/{raceId}/{runnerId}?fields=distance,runnerPlace')
const updateRunnerEmail = service.resource('runners/update-attributes/{runnerId}')
const userInfo = service.resource('users/{login}')
const runnerPastRuns  = service.resource('runner-race-resumes/get-race-resumes')

const removeRaceResume = service.resource('runner-race-resumes/{raceResumeId}')
const createRunnerRaceResume = service.resource('runner-race-resumes')
export default {
  // Read
  getAll (id) {
    return resource.get({id: id}) 
  },

  //Add Runner to Race

  add(runnerId, raceId){

    return addrunner.update({idRacer:raceId,idRunner: parseInt(runnerId)}, {})
  },
  //Remove Runner from Race

  remove(runnerId, raceId){

    return removerunner.delete({idRacer:raceId,idRunner: parseInt(runnerId)}, {})
  },
  //Get runner Data
  getByIds (raceId, idsRunners) {
    // FIXED: If idsRunners is an empty array or not provided, send empty array to get all runners
    // Otherwise, wrap single runner ID in array
    var id = []
    if (Array.isArray(idsRunners) && idsRunners.length === 0) {
      // Send empty array to get all runners (like live run page does)
      id = []
    } else if (idsRunners !== null && idsRunners !== undefined) {
      // Single runner ID - wrap in array
      id.push(idsRunners)
    }
    // CRITICAL: Add bestDuration=true to match the working WebSocket API
    // This parameter is required to get post-run answers and other complete data
    return runnerInfo.save({raceId: raceId, bestDuration: true}, JSON.stringify(id))
  },


  getByRunnerId (id) {
  // Use the new comprehensive profile-info endpoint
  return runnerProfileInfo.query({runnerId: id})
  },

  // Legacy method - keeping for backward compatibility
  getByRunnerIdLegacy (id) {
    return runnerInfoPerId.get({runnerId: id})
  },

  //Get runner Subcribed races

  getSubscribedRaces(runnerId){
    return resourceSubscribed.get({id: runnerId}) 
  },
  //Get final position of runner in  race

  getFinalPosition(raceResumeId){
    return resourceFinalposition.get({raceResumeId: raceResumeId}) 
  },

  saveMemo(data) {
    return runnerMemo.save({runnerId: data.runnerId}, data.memo)
  },

  saveCmMemo(data) {
    return runnerCmMemo.save({runnerId: data.runnerId}, data.cmmemo)
  },
  updateDistance(data) {
    return runnerUpdateDistance.save({raceId: data.raceId}, data.race)
  },

  getRunnerDistance(data) {
    return runnerGetDistance.get({raceId: data.raceId,runnerId: data.runnerId })
  },

  getRunnerPastRuns(data){
    var formdata = this.getFormData(data)
    return runnerPastRuns.save({},formdata)
  },

  getFormData(object) {
    const formData = new FormData()
    Object.keys(object).forEach(key => formData.append(key, object[key]))
    return formData
  },

  getBestDuration(id) {
    return runnerBestDuration.get({runnerId: id})
  },
  getCurrentYearBestDuration(id, year){
    return runnerCurrentYearBestDuration.get({runnerId: id,year: year})
  },
  getRunnerMedals(id) {
    return runnerMedals.get({runnerId: id})
  },

  updateEmail(id, newemail){
     let updateEmail = {
       email: newemail
     }
    return updateRunnerEmail.save({runnerId: id},updateEmail)
  },

  getUserInfo(login) {
    return userInfo.get({login: login})
  },

  deleteRaceResume(raceResumeId){
    return removeRaceResume.delete({raceResumeId:raceResumeId}, {})
  },

  addRaceResume(data){
    return createRunnerRaceResume.save(data)
  }

}


// WEBPACK FOOTER //
// ./src/services/runnersByRace.js